/**
 * Colors
 */
export const black_0 = '#fff'
export const white = black_0
export const orangeDark = '#EA8E33'
export const greyLight = '#AFAFAF'
export const greyMedium = '#888887'
export const greyDark = '#60605F'
export const textPlaceholder = '#AFAFAF'
export const background1 = '#ffffff'
export const background2 = '#EEF2F7'
export const background3 = '#F2F5F9'
export const accentGrey = '#60605F'
export const redLight = '#FBEAE8'
export const accentDark = '#DA291C'
export const accentLight = '#E15449'
export const brandDark = '#373737'
export const orangeLight = '#E67300'
export const brandLight = '#E67300'
export const menuBackground = '#373737'
export const pageBackground = '#EBF0F5'
export const error = '#FE6464'
export const errorLight = '#ff1c00'
export const errorBackground = '#fae7e7'
export const warning = '#856404'
export const success = '#5cce8f'
export const successLight = '#1fd26f'
export const active = '#F8D4D2'
export const backgroundActive = '#FBEAE8'
export const backgroundPressed = '#FBEAE8'
export const warningBackground = '#FCB314'
export const infoIcon = '#E67300'
export const infoHover = '#EA8E33'
export const positiveAlert = '#5cce8f'
export const positiveAlertHover = '#64e09b'
export const chartPrimaryColor = '#DA291C'
export const line1 = '#D7D7D7'
export const line2 = '#EBEBEB'
export const highlightWarning = '#FFF7E7'
export const textSecondary = '#60605F'

// Paymark
export const cyan = '#DA291C'
export const teal = '#B5211A'
export const boxshadowcyan = '#E97F77'
export const black = '#000000'
export const lightBlue = '#E67300'
export const yellow = '#FCB314'
export const icon = '#DA291C'
export const highlight = '#FBEAE8'
export const boxshadow = '#F0A9A4'
export const heading = '#000000'
